import axios from 'axios';
import { useCallback, useReducer } from 'react';
import { User } from '../../types/Types';
import ActionTypes from '../Action.types';
import UserReducer from './User.reducer';

const INITIAL_STATE = {
  users: [],
  isLoading: false,
  errMessage: '',
};

const UserHooks = () => {
  const [state, dispatch] = useReducer(UserReducer, INITIAL_STATE);
  // ------------------------------------------------------------------- //
  // ----------------------------- FIND ALL----------------------------- //
  // ------------------------------------------------------------------- //
  const findAll = useCallback(async () => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      const res: any = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/users`
      );

      const data = res.data.map((user: User) => {
        return { ...user, id: user._id };
      });

      dispatch({ type: ActionTypes.find, payload: data });
    } catch (err: any) {
      if (err.response) {
        console.log(err.response.data.message);
      } else {
        console.log(err.message);
      }
    }
  }, []);

  // ----------------------------------------------------------------------- //
  // ----------------------------- Create ---------------------------------- //
  // ----------------------------------------------------------------------- //

  const create = (createData: any) => {
    try {
      dispatch({ type: ActionTypes.create, payload: createData });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  // ----------------------------------------------------------------------- //
  // ----------------------------- UPDATE ---------------------------------- //
  // ----------------------------------------------------------------------- //

  const editUser = (editData: any) => {
    try {
      dispatch({ type: ActionTypes.update, payload: editData });
    } catch (err: any) {
      console.log(err.message);
    }
  };
  // ------------------------------------------------------------------ //
  // ----------------------------- DELETE ----------------------------- //
  // ------------------------------------------------------------------ //

  const deleteUser = async (userId: string) => {
    dispatch({ type: ActionTypes.delete, payload: userId });
  };
  // ----------------------------- CLEAR ----------------------------- //

  return { state, findAll, create, editUser, deleteUser };
};

export default UserHooks;
